import { ref } from "vue"

class ComponenteEmailService {
    setup({ respostas }) {
        const emailInformado = ref(respostas ?? '')
        const error = ref(false)
        return { emailInformado, error }
    }
}

export default new ComponenteEmailService();